/** Shared Spy SERP rank / trend presentation (token-based). */

export function getSpyRankBadgeClass(rank: number): string {
  if (!rank || rank > 100) {
    return "badge-muted font-normal hover:opacity-90";
  }
  if (rank === 1) return "badge-chart-1 hover:opacity-90";
  if (rank <= 3) return "badge-chart-3 hover:opacity-90";
  if (rank <= 10) return "badge-chart-2 hover:opacity-90";
  return "badge-muted font-mono hover:opacity-90";
}

export function getSpyTrendBadgeClass(change: number): string {
  if (!change || change === 0) {
    return "font-normal text-muted-foreground border-border bg-muted/30";
  }
  if (change > 0) return "badge-trend-up font-normal";
  return "badge-trend-down font-normal";
}

export function getSpyTrendTextClass(change: number): string {
  if (!change || change === 0) {
    return "flex items-center justify-end text-sm text-muted-foreground";
  }
  if (change > 0) {
    return "signal-text-positive flex items-center justify-end text-sm font-medium tabular-nums";
  }
  return "signal-text-negative flex items-center justify-end text-sm font-medium tabular-nums";
}
